"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.erc1155 = void 0;
const BalanceOf1155ABI_json_1 = __importDefault(require("../abi/BalanceOf1155ABI.json"));
const parseBlockTag_1 = require("../utils/parseBlockTag");
const ethers_1 = require("ethers");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
/**
 * Calculates `balanceOf` for specific token id within 1155 contract
 */
const erc1155 = (tokenId, multiplier = 1) => {
    return async (userAddress, communityAddress, blockTag, provider) => {
        const contract = new ethers_1.Contract(communityAddress, BalanceOf1155ABI_json_1.default, provider);
        const balance = await contract.balanceOf(userAddress, tokenId, {
            blockTag: (0, parseBlockTag_1.parseBlockTag)(blockTag),
        });
        return new bignumber_js_1.default(balance.toString()).times(multiplier).toNumber();
    };
};
exports.erc1155 = erc1155;
